import React, { Component } from 'react';
import DataTable from "react-data-table-component";
import $ from "jquery";
import { ToastContainer, toast } from "react-toastify";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import { tokenVerification } from './Utils';

class SkillMetaData extends Component {
    constructor() {
        super();
        this.state = {
            dataStartedProcessing: false,
            showLoader: false,
            // data: [{
            //     id: '',
            //     displayName: '',
            //     skillId: '',
            //     type: '',
            //     slotName: '',

            // }],
            data: [],
            editedDisplayName: "",
            editedType: "",
            editedSlotName: "",
            disabled: false,
            editedId: "-1",
            pageNum: null,
            paginationValue: 10,
            hidden: false,
            hideDeletePopup: false,
            hideDeleteSuccessPopup: false,
            skillType: [],
            searchTerm: "",
            noMatchingData: false,
            isLoading: true,

        }
        this.saveImageSrc = "./assets/images/baseline_save_white_24dp.png";
        this.editImageSrc = "./assets/images/edit2.png";
    }
    componentDidMount() {
        var thisController = this;

        this.fetchSkillMetaDataDetails();
        this.fetchSkillMetaDataType();

        if (this.props.location.state != undefined) {
            this.setState({ pageNum: this.props.location.state.pageNum });
        }

    }

    addNewSkillDataRow = () => {
        var thisController = this;
        thisController.state.paginationValue = thisController.state.paginationValue + 5;
        if (thisController.state.pageNum != 0) {
            thisController.setState({ pageNum: 0 })
        }
        this.state.data.unshift({
            id: '',
            displayName: '',
            skillId: '',
            type: '',
            slotName: '',
        });
        this.setState({
            data: this.state.data,
            noMatchingData: false,
            disabled: true,
            editedId: "",
        })
    }

    makeCelledit(row, e) {
        this.markAsBeingEdited(row.id);
        this.state.editedDisplayName = row.displayName;
        this.state.editedType = row.type;
        this.state.editedSlotName = row.slotName;
        this.setState(this.state);
    }

    markAsBeingEdited(id) {
        this.state.editedId = id;
        var stateObj = this.state;
        this.setState(stateObj);
    }
    fetchSkillMetaDataType = () => {
        var thisController = this;
        $.ajax({
            url: "/my-jeeva-api/load-skillmetadata-type",
            method: 'GET',
            headers: {
                'Authorization': "Bearer " + localStorage.getItem("access_token"),

            },
            success: function (res) {
                if (res.success === true) {
                    thisController.state.skillType = res.result;
                    thisController.state.noMatchingData = false;
                    thisController.setState(thisController.state);
                } else {
                    thisController.notifyFailedResponse(res.result);
                }
            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    tokenVerification();
                }
            }
        })
    }

    CustomNoDataComponent = () => (
        <div style={{ padding: '20px', textAlign: 'center' }}>
            <p>There are no skill data present. </p>
        </div>
    );

    fetchSkillMetaDataDetails = () => {
        var thisController = this;
        var skillId = this.props.location.state.skillId
        $.ajax({
            url: "/my-jeeva-api/skill-meta-data",
            method: 'GET',
            headers: {
                'Authorization': "Bearer " + localStorage.getItem("access_token"),
            },
            data: { skillId },
            success: function (res) {
                if (res.success === true) {
                    var messages = res.result;
                    thisController.state.disabled = false;
                    thisController.state.noMatchingData = false;
                    thisController.state.isLoading = false;
                    thisController.state.showLoader = true;
                    thisController.state.data = messages;
                    thisController.data = messages;
                    thisController.setState(thisController.state);
                } else {
                    // thisController.notifyError(res.result);
                }
            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    tokenVerification();
                }
            }
        });
    }

    saveSkillMetaDataDetails(row, e) {
        var thisController = this;
        var namePattern = new RegExp(/^([a-zA-Z\s-])*$/);

        row.displayName = document.getElementById("displayName" + row.id).innerText.trim();
        row.slotName = document.getElementById("slotName" + row.id).innerText.trim();

        var displayName = row.displayName;
        var slotName = row.slotName;
        var skillMetaDataType = row.type;
        if (displayName == "" || slotName == "" || skillMetaDataType == "") {
            thisController.notifyMsgFieldEmpty();
        }
        else if (!namePattern.test(displayName)) {
            thisController.notifyImproperName();
        }

        else {
            thisController.state.editedId = "-1";
            thisController.state.dataStartedProcessing = true;
            thisController.setState(thisController.state);
            var saveData = {
                skillId: this.props.location.state.skillId,
                displayName: row.displayName,
                type: row.type,
                slotName: row.slotName
            }

            var timer = setInterval(function () {
                clearTimeout(timer);

                $.ajax({
                    url: "/my-jeeva-api/add-skill-metadata",
                    method: 'POST',
                    headers: {
                        'Authorization': "Bearer " + localStorage.getItem("access_token"),
                        'Content-Type': "application/json",

                    },
                    data: JSON.stringify(saveData),
                    success: function (res) {
                        if (res.success === true) {
                            thisController.state.dataStartedProcessing = false;
                            thisController.notifySkillMetaDataAdded();
                            thisController.fetchSkillMetaDataDetails();
                            thisController.setState({ disabled: false, dataStartedProcessing: false });
                        } else {
                            thisController.notifyFailedResponse(res.result);
                        }
                    },
                    error: function (xhr) {
                        if (xhr.status == 401) {
                            window.location.href = "";
                        }
                    }
                })

            }, 2000);
        }
    }

    updateSkillMetaDataDetails(row, e) {
        row.displayName = document.getElementById("displayName" + row.id).innerText.trim();
        row.slotName = document.getElementById("slotName" + row.id).innerText.trim();
        var thisController = this;

        var namePattern = new RegExp(/^([a-zA-Z\s-])*$/);


        var displayName = thisController.state.editedDisplayName;
        var skillMetaDataType = row.type;
        var slotName = thisController.state.editedSlotName;

        if (displayName == "" || skillMetaDataType == "" || slotName == "") {
            thisController.notifyMsgFieldEmpty();
        }
        else if (!namePattern.test(displayName)) {
            thisController.notifyImproperName();
        }

        else {
            var updatedData = {
                id: row.id,
                displayName: displayName,
                skillId: this.props.location.state.skillId,
                type: row.type,
                slotName: slotName,
            };
            $.ajax({
                url: "/my-jeeva-api/update-skill-metadata",
                method: 'PATCH',
                headers: {
                    'Authorization': "Bearer " + localStorage.getItem("access_token"),
                    'Content-Type': 'application/json',
                },
                data: JSON.stringify(updatedData),
                contentType: "application/json; charset=UTF-8",
                success: function (res) {
                    if (res.success === true) {
                        thisController.state.editedId = "-1";
                        thisController.notifySkillMetaDataUpdate();
                        thisController.fetchSkillMetaDataDetails();
                    } else {
                        thisController.notifyFailedResponse(res.result);
                    }
                },
                error: function (xhr) {
                    if (xhr.status == 401) {
                        window.location.href = "";
                    }
                }


            })
        }

    }
    openDeletePopUp = (row) => {

        confirmAlert({
            title: 'Confirm to Delete',
            message: `Are you sure you want to delete ${row.displayName} ?`,
            buttons: [
                {
                    label: 'Yes',
                    onClick: () => this.callDeleteSkillMetaData(row.id)
                },
                {
                    label: 'No',
                }
            ]
        });
    }

    callDeleteSkillMetaData = (id) => {
        let skillMetaData = this.state.data;
        let deleteApiViewController = this;
        var deleteConstructorVariables = this;

        if (id == "") {
            deleteApiViewController.setState({ deleteRow: true });
            deleteConstructorVariables.setState({ hideDeletePopup: false });
            deleteConstructorVariables.setState({ hideDeleteSuccessPopup: true });
            skillMetaData.splice(id, 1);
        } else {
            $.ajax({
                url: "/my-jeeva-api/delete-skill-metadata/" + id,

                method: 'DELETE',
                headers: { "Authorization": "Bearer " + localStorage.getItem("access_token") },
                success: function (res) {

                    if (res.success === true) {

                        deleteApiViewController.setState({ deleteRow: true });
                        deleteConstructorVariables.setState({ hideDeletePopup: false });
                        deleteConstructorVariables.notifyDelete();
                        skillMetaData.splice(id, 1);
                        deleteApiViewController.refreshData();
                    } else {
                        // skillMetaData.notifyError();
                    }
                },
                error: function (xhr) {
                    if (xhr.status == 401) {
                        window.location.href = "";
                    }
                }
            });
        }

        if (this.state.deleteRow) {
            this.state.data.splice(id, 1);
        }
        deleteConstructorVariables.fetchSkillMetaDataDetails();
    }

    notifyError() {
        toast.dismiss();
        toast(<b><img src="assets/images/warn.svg" style={{ paddingRight: '0px', height: '20px', width: '20px' }}
            content="" />&nbsp;&nbsp;Oops! Error occurred.Please try again</b>, {
            position: "top-center"
        });
    }

    notifyFailedResponse(response) {
        toast.dismiss();
        toast(<b style={{ color: "red" }}>{response}</b>, {
            position: "top-center",
            color: "red"

        });
    }

    notifyDataProcessing() {
        toast.dismiss();
        toast(
            <b>
                <img
                    src="assets/images/warn.svg"
                    style={{ paddingRight: "0px", height: "20px", width: "20px" }}
                    content=""
                />
                &nbsp;&nbsp;Hold on.Your data is saving...
            </b>,
            {
                position: "top-center",
            }
        );
    }
    notifySkillMetaDataAdded() {
        toast.dismiss();
        toast(
            <b>
                <img
                    src="assets/images/done.svg"
                    style={{ paddingRight: "0px" }}
                    content=""
                />
                &nbsp;&nbsp; Details added successfully
            </b>,
            {
                position: "top-center",
            }
        );
    }
    notifySkillMetaDataUpdate() {
        toast.dismiss();
        toast(
            <b>
                <img
                    src="assets/images/done.svg"
                    style={{ paddingRight: "0px" }}
                    content=""
                />
                &nbsp;&nbsp;Details updated successfully
            </b>,
            {
                position: "top-center",
            }
        );
    }

    notifyImproperName() {
        toast.dismiss();
        toast(<b><img src="assets/images/warn.svg"
            style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />
            &nbsp;&nbsp;Please provide a valid name</b>, {
            position: "top-center"
        });
    }

    notifyDelete() {
        toast.dismiss();
        toast(<b><img src="assets/images/done.svg" style={{ paddingRight: '0px' }} content="" />&nbsp;&nbsp;Detail deleted successfully</b>, {
            position: "top-center",
        });
    }

    notifyMsgFieldEmpty() {
        toast.dismiss();
        toast(<b><img src="assets/images/warn.svg"
            style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />
            &nbsp;&nbsp;Please fill all the fields</b>, {
            position: "top-center"
        });

    }
    refreshData = (id) => {
        this.state.data = [];
        this.state.editedId = "-1";
        this.state.noMatchingData = false;
        this.state.isLoading = true;
        this.state.searchTerm = "";
        this.state.disabled = false;
        this.setState(this.state);
        this.fetchSkillMetaDataDetails();
    }

    handleDisplayNameChange = (e) => {
        this.state.editedDisplayName = e.currentTarget.textContent.trim();
        this.setState(this.state);
    }

    handleSlotNameChange = (e) => {
        this.state.editedSlotName = e.currentTarget.textContent.trim();
        this.setState(this.state);
    }

    onChangeOfSkillType = (row, e) => {
        var updatedData = this.state.data.map((record) => {
            if (record.id === row.id) {
                record.type = e.target.value;
            }
            return record;
        });
        this.setState({
            data: updatedData
        })
        console.log("Selected Type: " + e.target.value);
    }

    goBackFromSubTab = () => {
        var pageNum = this.props.location.state.pageNum;
        this.props.history.push({
            pathname: "/projectmgmt/virtual-agent-skills",
            state: {
                goBackToFaq: true,
                pageNum: pageNum,
                skillId: this.props.location.state.skillId,
                virtualAgentId: this.props.location.state.virtualAgentId,
                VirtualAgentName: this.props.location.state.VirtualAgentName
            }
        });
    }

    onPageChange = (e) => {
        this.setState({ pageNum: e })
    }

    caseInsensitiveSort = (field) => (rowA, rowB) => {
        const a = rowA[field] ? rowA[field].toLowerCase() : '';
        const b = rowB[field] ? rowB[field].toLowerCase() : '';

        if (a > b) {
            return 1;
        }
        if (b > a) {
            return -1;
        }
        return 0;
    };

    handleSearch = (event) => {
        var thisController = this;
        thisController.state.searchTerm = event.target.value;
        thisController.state.isLoading = true;
        thisController.state.data = [];
        var skillId = this.props.location.state.skillId
        thisController.setState(thisController.state);

        $.ajax({
            url: "/my-jeeva-api/search-skill-meta-data",
            method: "GET",
            data: {
                searchTerm: thisController.state.searchTerm,
                skillId: skillId
            },
            headers: {
                Authorization: "Bearer " + localStorage.getItem("access_token"),
            },

            success: function (res) {
                if (res.success === true) {
                    if (res.result.length > 0) {
                        thisController.state.data = [];
                        thisController.state.noMatchingData = false;
                        thisController.state.isLoading = false;
                        thisController.setState(thisController.state);
                        thisController.state.data = res.result;
                        thisController.setState(thisController.state);
                    } else {
                        thisController.state.noMatchingData = true;
                        thisController.state.isLoading = false;
                        thisController.setState(thisController.state);
                    }
                }
            },
            error: function (xhr) {

            },
        });

    };


    render() {
        const { data } = this.state;
        var agentController = this;

        const columns = [
            {
                name: <b style={{ fontSize: "16px" }}> Display Name</b>,
                sortable: true,
                sortFunction: this.caseInsensitiveSort('displayName'),
                // width: "19vw",
                selector: (row) => (
                    <div name="name">
                        <div
                            className="textarea"
                            style={{
                                background: "white",
                                height: "2.7em",
                                resize: "none",
                                paddingLeft: "2px",
                                paddingTop: "6px",
                                width: "100%",
                                fontSize: "15px",
                                border:
                                    row.id == "" || row.id == this.state.editedId
                                        ? "1px solid #D2D4DC"
                                        : "none",
                                borderRadius: row.id == "" ? "2px" : "none",
                            }}
                            onInput={(e) => {
                                this.handleDisplayNameChange(e, row);
                            }}
                            id={"displayName" + row.id}
                            contentEditable={
                                !(row.id == "" ? false : row.id != this.state.editedId)
                                    ? "plaintext-only"
                                    : false
                            }
                        >
                            {row.displayName}
                        </div>
                    </div>
                ),
            },
            {
                name: <b style={{ fontSize: "16px" }}>Slot Name</b>,
                sortable: true,
                sortFunction: this.caseInsensitiveSort('slotName'),
                // width: "45vw",
                selector: (row) => (
                    <div>
                        <div
                            className="textarea"
                            style={{
                                background: "white",
                                height: "2.7em",
                                resize: "none",
                                paddingLeft: "2px",
                                paddingTop: "6px",
                                width: "100%",
                                border:
                                    row.id == "" || row.id == this.state.editedId
                                        ? "1px solid #D2D4DC"
                                        : "none",
                                borderRadius: row.id == "" ? "2px" : "none",
                                overflowY: "scroll"
                            }}
                            onInput={(e) => {
                                this.handleSlotNameChange(e, row);
                            }}
                            id={"slotName" + row.id}
                            name={"slotName" + row.id}
                            contentEditable={
                                !(row.id == "" ? false : row.id != this.state.editedId)
                                    ? "plaintext-only"
                                    : false
                            }
                        >
                            {row.slotName}
                        </div>
                    </div>
                ),
            },
            {
                name: <b style={{ fontSize: "16px" }}>Type</b>,
                sortable: true,
                sortFunction: this.caseInsensitiveSort('type'),
                selector: (row) => {
                    const isEditing = row.id === this.state.editedId;
                    const element = isEditing ? (
                        <select
                            className="input-group form-control select2 "
                            onChange={(e) => this.onChangeOfSkillType(row, e)}
                            value={row.type}
                            id={"type" + row.id}
                            style={{
                                marginLeft: "0vw",
                                padding: "0px",
                                paddingTop: "5px",
                                paddingLeft: "5px",
                                background: "white",
                                border: "1px solid #D2D4DC",
                                borderRadius: "2px",
                            }}
                        >
                            <option>Choose Type</option>
                            {this.state.skillType.map((typeName) => (
                                <option value={typeName}>
                                    {typeName}
                                </option>
                            ))}

                        </select>
                    ) : (
                        <div
                            className="textarea"
                            style={{
                                background: "white",
                                height: "2.7em",
                                resize: "none",
                                paddingLeft: "2px",
                                paddingTop: "6px",
                                width: "100%",
                                border: "none",
                                overflow: "hidden",
                            }}
                        >
                            {row.type}
                        </div>
                    );
                    return (
                        <div className="container-fluid" style={{ textAlign: "left" }}>
                            {element}
                        </div>
                    );
                },
            },
            {
                name: <b style={{ fontSize: "16px" }}>Actions</b>,
                width: 100,
                selector: (row) => (
                    <div id="action">
                        <button
                            style={{
                                backgroundColor: "#ffffff",
                                border: "none",
                                marginLeft: '-6px'
                            }} >
                            <img className="img-responsive"
                                title={row.id == "" || (row.id == this.state.editedId) ? 'Save' : 'Edit'}
                                style={{
                                    marginTop: '6px',
                                    backgroundColor: '#282a65',
                                    borderRadius: '5px',
                                    padding: '1px',
                                    width: '100%',
                                    fontSize: '15px'
                                }}
                                src={row.id == "" ? this.saveImageSrc : ((row.id != this.state.editedId) ? this.editImageSrc : this.saveImageSrc)}
                                onClick={(e) => {
                                    this.state.dataStartedProcessing
                                        ? this.notifyDataProcessing() :
                                        row.id == "" ? this.saveSkillMetaDataDetails(row, e) : (row.id == this.state.editedId) ?
                                            this.updateSkillMetaDataDetails(row, e) : this.makeCelledit(row, e);
                                }}
                            />
                        </button>
                        <button
                            style={{
                                backgroundColor: "#ffffff",
                                border: "none",
                                marginTop: '-9px',
                                marginLeft: '-6px'
                            }}
                            title="Delete">
                            <img className="img-responsive"
                                src={"./assets/images/baseline_delete_white_24dp.png"}
                                title="Delete"
                                style={{
                                    marginTop: '6px',
                                    backgroundColor: '#282a65',
                                    borderRadius: '5px',
                                    padding: '1px'
                                }}
                                onClick={() => (row.id) === '' ?
                                    this.fetchSkillMetaDataDetails() :
                                    this.openDeletePopUp(row)}
                            />
                        </button >

                    </div>
                ),
            },
        ];
        return (
            <div style={{ background: "#F9F9FB", marginRight: "1%" }}>
                {/* for toaster */}
                <link rel="stylesheet" href="assets/css/ReactToastify.css" />
                {/* for reactTable */}
                <link rel="stylesheet" href="assets/css/React_Table_CSS/react-table.css" />


                {/*for dialog component */}
                <link href="assets/css/ej2-base.css" rel="stylesheet" />
                <link href="assets/css/ej2-react-buttons.css" rel="stylesheet" />
                <link href="assets/css/ej2-react-popups.css" rel="stylesheet" />
                <link href="assets/css/ej2-inputs.css" rel="stylesheet" />
                <link href="assets/css/screenResolution.css" rel="stylesheet" />
                {/* Font Awesome Icons */}
                <link rel="stylesheet" href="plugins/font-awesome/css/font-awesome.min.css" />
                {/* IonIcons */}
                <link rel="stylesheet" href="assets/fonts/flat-icon/flaticon.css" />
                {/* Select2 */}
                <link rel="stylesheet" href="plugins/select2/select2.min.css" />
                <link rel="stylesheet" href="assets/css/toggleButton.css" />
                <link rel="stylesheet" href="./assets/css/styles.css" />
                <div className="content-header">
                    <div className="container-fluid">
                        <div className="row">
                        </div>
                        <div className="row">
                            <div className="col-sm-4" style={{ marginTop: '16px' }}  >
                                <img src="assets/images/arrow.svg"
                                    style={{ paddingRight: "30%", cursor: 'pointer' }}
                                    onClick={this.goBackFromSubTab}
                                />
                            </div>
                            <div style={{ marginLeft: "-27vw" }}>
                                <h6 style={{ color: '#282a65', textAlign: 'center', marginTop: '20px' }}>
                                    Skill Data of {this.props.location.state.skillName}</h6>
                                {/* <h6 className="taglineTxt" style={{ textAlign: 'center' }}>FAQ Answers</h6> */}
                            </div>
                            <div style={{ marginLeft: "50vw", marginTop: "1vh" }}>
                                <input
                                    type="text"
                                    style={{
                                        width: "12vw",
                                        border: "2px solid #777676",
                                        borderRadius: "10px",
                                        padding: "10px",
                                        height: "0.7vw"
                                    }}
                                    value={this.state.searchTerm}
                                    onChange={this.handleSearch}
                                    placeholder="Search ..."
                                />
                            </div>
                            {/* Add button */}
                            <div style={{ marginLeft: "3vw" }}>
                                <button className="btn action-button "
                                    title="Add"
                                    id="addMsg"
                                    onClick={this.state.disabled ? this.notifyMsgFieldEmpty : this.addNewSkillDataRow}
                                >
                                    <img src="assets/images/add_white_24dp.png" />
                                </button>
                                <button
                                    onClick={this.refreshData}
                                    title="Refresh"
                                    className="btn action-button">
                                    <img src="./assets/images/refresh_white_24dp.png"></img>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div className="row" style={{ marginLeft: '15px', marginTop: '10px' }}>
                        <div className="col-lg-12 ">
                            {!this.state.noMatchingData &&
                                <div className="card">
                                    {this.state.isLoading && (
                                        <div style={{ padding: '20px', textAlign: 'center' }}>
                                            <p>Loading ...</p>
                                        </div>
                                    )}
                                    {!this.state.isLoading && this.state.data.length === 0 && (
                                        <div style={{ padding: '20px', textAlign: 'center' }}>
                                            <p>There are no skill data present.</p>
                                        </div>
                                    )}
                                    {(!this.state.isLoading && this.state.data.length > 0) && (

                                        <DataTable
                                            data={this.state.data}
                                            columns={columns}
                                            defaultPageSize={10}
                                            pageSizeOptions={[5, 10, 15]}
                                            pagination={this.state.paginationValue}
                                            onPageChange={this.onPageChange}
                                            page={this.state.pageNum}
                                            noDataComponent={<this.CustomNoDataComponent />}
                                        />
                                    )}
                                </div>}

                            <ToastContainer className="Toast-at-center" />
                        </div>
                    </div>
                    <div className='card'>
                        {this.state.noMatchingData &&
                            <div style={{ padding: '20px', textAlign: 'center', boxShadow: "0 0 10px rgba(0, 0, 0, 0.2)" }}>
                                <p>No matching options found ...</p>
                            </div>
                        }
                    </div>
                </div>
            </div>
        )
    }
}

export default SkillMetaData;


// WEBPACK FOOTER //
// src/my-jeeva/projectmgmt/SkillMetaData.js